<mat-card>
  <app-pie-chart *ngIf="accounts" [accounts]="accounts" [categories]="categories"
    (legendClicked)="onLegendClicked($event)"></app-pie-chart>
  <div class="spacer"></div>
  <app-line-chart *ngIf="accounts" [accounts]="accounts" [month]="month" [categories]="categories"
    [displayedLabels]="displayedLabels"></app-line-chart>
</mat-card>